/**
 * =================
 * ALERTS MINI TOOL
 * tool
 * =================
 */
app.alerts = (function(module) {

    var $ch = 0;

    module.init = (function typeIt() {
        var $typer = app.$('.info-animate');
            txt = $typer.attr("data-text");
            if (typeof (txt) != 'undefined') {
                tot = txt.length;
            } else {
                return;
            }
        if($ch > tot) return;
        $typer.text( txt.substring(0, $ch++) );
        return setTimeout(typeIt, ~~(Math.random()*(300-60+1)+60));

    });

    return module;

}(app.alerts || {}));